import React, {Component} from "react";
import {Router} from "react-router-dom";
import {createBrowserHistory} from "history";

// import "react-dates/initialize";
// import "react-dates/lib/css/_datepicker.css";
import "rsuite/dist/rsuite.min.css";
import "./assets/css/App.css";

import Auth from "components/Auth";
import Home from "components/Home";

const history = createBrowserHistory();
const HomeWithAuth = Auth.withAuth(Home);

class App extends Component {
    render() {
        return (
            <Router history={history}>
                <Auth.Provider history={history}>
                    <HomeWithAuth />
                </Auth.Provider>
            </Router>
        );
    }
}

export default App;
